import { ReactNode } from "react";
import classnames from "classnames";
import { useFormContext, useWatch } from "react-hook-form";
// import omit from "lodash/omit";

import styles from "./index.module.scss";

import { CheckMarkRounded } from "../Icons/general-interface-1";

type Props = {
  name: string;
  value?: string;
  label?: string | ReactNode;
  disabled?: boolean;
  disabledNonVisually?: boolean;
  className?: string;
  labelClassName?: string;
  requiredText?: string;
  readOnly?: boolean;
  tooltip?: ReactNode;
  textLink?: ReactNode;
};

// If you want a single checkbox with label, you should probably still use CheckboxGroup
export default (props: Props) => {
  const {
    value,
    name,
    label,
    disabled,
    disabledNonVisually = false,
    className,
    labelClassName,
    requiredText,
    readOnly,
    tooltip,
    textLink,
  } = props;

  const { register, getValues } = useFormContext();
  useWatch({ name });
  const atLeastOne = () => (getValues(name)?.length ? true : requiredText);

  return (
    <div
      key={`${value}-div`}
      className={classnames(styles.CheckboxWrapper, className)}
    >
      <label
        style={{
          ...(disabledNonVisually
            ? {
                pointerEvents: "none",
              }
            : {}),
        }}
        key={`${value}-label`}
        className={styles.Checkbox}
        htmlFor={value}
      >
        <input
          type="checkbox"
          className={styles.Input}
          disabled={disabled || readOnly}
          id={value}
          key={value}
          value={value}
          {...register(name, { validate: atLeastOne })}
        />
        <div
          key={`${value}-div-checked`}
          className={classnames(styles.Checked, {
            [styles.CheckedReadOnly]: readOnly,
          })}
        >
          <CheckMarkRounded color="white" aria-hidden="true" />
        </div>
        {label && (
          <div className={styles.labelContainer}>
            <span className={labelClassName || styles.Label}>
              {label} {tooltip}
            </span>
            {textLink}
          </div>
        )}
      </label>
    </div>
  );
};
